@if (visible) {
  <ng-container class="container">
    <div class="language-radio-div {{cssClassName}}">
      <label>{{label}}</label>
      <mat-button-toggle-group appearance="standard" [value]="selectedLangCodes?.[0]" (change)="onSelect($event.value)">
        @for (lang of (langs.slice(0,MAX_BUTTONS)); track lang) {
          @if (lang.code !== '') {
            <mat-button-toggle [value]="lang.code">{{ lang.name }}</mat-button-toggle>
          }
        }
      </mat-button-toggle-group>
      @if (langs.length > MAX_BUTTONS) {
        <button class="more-button" mat-button [matMenuTriggerFor]="menu" matTooltip="More languages"><mat-icon>more_vert</mat-icon></button>
        <mat-menu #menu="matMenu">
          @for (lang of (langs.slice(MAX_BUTTONS)); track lang) {
            <button mat-menu-item (click)="onSelect(lang.code)">
              <mat-icon>@if (isLanguageSelected(lang.code)) {
                check
              }</mat-icon>
              {{ lang.name }}
            </button>
          }
        </mat-menu>
      }
    </div>
  </ng-container>
}

